
const state = {

  __db: {
    aside_open: typeof window !== 'undefined' && window.innerWidth <= 500 ? false : true,
  },

  set( key, value ) {
    this.__db[key] = value;
    return value;
  },

  get(key) {
    return this.__db[key];
  },



}

export default state;



// WEBPACK FOOTER //
// ./src/global/data/State.js